import { globalStyles } from "@client/shared/constants";
const style = {
  callIcon: {
    width: 76,
    height: 76,
    // background: (props) =>
    //   props.enabled
    //     ? theme.cardIcon.enabledBackground
    //     : theme.cardIcon.disabledBackground,
    borderRadius: 50,
    margin: "auto",
    "& img": {
      height: 40,
    },
  },
  emailTag: {
    background: "#ffc617",
  },
  webhookTag: {
    background: "#ffa30a",
  },
  smsTag: {
    background: "#ffa30a",
  },
  glipTag: {
    background: "#ff2000",
  },
  tagDisabled: {
    ...globalStyles.background.color.primary.main,
  },
  tags: {
    bottom: 14,
    position: "absolute",
    width: "100%",
    left: 0,
  },
  selectionShadow: {
    boxShadow: "0px 1px 10px -1px #2d96f3",
  },
  wrapper: {
    width: 235,
    height: 228,
    boxSizing: "border-box",
  },
  switchLabel: {
    top: 1.5,
  },
};

export default style;
